var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_499",
    "data-name": "Group 499",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.4,
    height: 30,
    viewBox: "0 0 24.4 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M17.8,3h2.8a2.808,2.808,0,0,1,2.8,2.8V25.4a2.808,2.808,0,0,1-2.8,2.8H3.8A2.808,2.808,0,0,1,1,25.4V5.8A2.808,2.808,0,0,1,3.8,3H6.6",
    transform: "translate(0 0.8)",
    fill: "none",
    stroke: "#e13505",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M6.4,1h8.4a1.4,1.4,0,0,1,1.4,1.4V5.2a1.4,1.4,0,0,1-1.4,1.4H6.4A1.4,1.4,0,0,1,5,5.2V2.4A1.4,1.4,0,0,1,6.4,1Z",
    transform: "translate(1.6)",
    fill: "none",
    stroke: "#e13505",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/my-account.b05d17ed5fbf96a5de2b84a0957bda18.svg";
export { ForwardRef as ReactComponent };